const eventCategory = "Party_peshi";

export const chrBannerViewed = {
    event: "CHR_banner_viewed",
    eventAction: "CHR_banner_viewed",
    eventCategory: "DIY_flow"
};

export const videoPlay = {
    event: "video_play",
    eventAction: "play",
    eventCategory
};

export const videoPause = {
    event: "video_pause",
    eventAction: "pause",
    eventCategory
};

export const videoTimeWatched = {
    event: "video_time_watched",
    eventAction: "time_watched",
    eventCategory
};

export const videoBufferError = {
    event: "video_buffer_error",
    eventAction: "buffer_error",
    eventCategory
};

export const videoFullScreen = {
    event: "video_fullscreen",
    eventAction: "fullscreen",
    eventCategory
};
